/* Voss Product Hero — price/CTA sync (works with the Kaching Bundles variant switcher) */

document.addEventListener('DOMContentLoaded', function () {
  var root = document.querySelector('.voss-buy');
  if (!root) return;

  var variants = window.vossVariants || [];
  var atcText = window.vossAtcText || 'In den Warenkorb';
  var input = root.querySelector('input[name="id"]');
  var priceNow = document.getElementById('vossPriceNow');
  var priceWas = document.getElementById('vossPriceWas');
  var priceSave = document.getElementById('vossPriceSave');
  var atcButton = root.querySelector('.voss-atc');
  var atcLabel = root.querySelector('.voss-atc .add-to-cart-text__content');

  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency })
      .format(cents / 100)
      .replace(/\s/g, '');
  }

  var lastVariantId = null;

  function update() {
    if (!input) return;
    var id = parseInt(input.value, 10);
    if (!id || id === lastVariantId) return;
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) { matched = variants[i]; break; }
    }
    if (!matched) return;
    lastVariantId = id;

    if (priceNow) priceNow.textContent = formatMoney(matched.price);

    if (matched.compare_at_price && matched.compare_at_price > matched.price) {
      if (priceWas) {
        priceWas.textContent = formatMoney(matched.compare_at_price);
        priceWas.style.display = 'inline';
      }
      if (priceSave) {
        var savePercent = Math.round((matched.compare_at_price - matched.price) * 100 / matched.compare_at_price);
        priceSave.textContent = 'Spare ' + savePercent + '%';
        priceSave.style.display = 'inline';
      }
    } else {
      if (priceWas) priceWas.style.display = 'none';
      if (priceSave) priceSave.style.display = 'none';
    }

    if (atcButton) {
      var labelText = matched.available ? atcText : (atcButton.dataset.soldOutText || 'Ausverkauft');
      atcButton.disabled = !matched.available;
      atcButton.querySelectorAll('.add-to-cart-text__content, .btn__icon-text').forEach(function (el) {
        el.textContent = labelText;
      });
    }
  }

  // Built-in dropdown variant picker (used when the bundle app is not active)
  var selects = Array.prototype.slice.call(root.querySelectorAll('.voss-bundle-select'));
  function applySelects() {
    if (!selects.length || !input) return;
    var opts = selects.map(function (s) { return s.value; });
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v.options.length !== opts.length) continue;
      var ok = true;
      for (var k = 0; k < opts.length; k++) { if (v.options[k] !== opts[k]) { ok = false; break; } }
      if (ok) { matched = v; break; }
    }
    if (matched) { input.value = matched.id; update(); }
  }
  selects.forEach(function (s) { s.addEventListener('change', applySelects); });

  // Fallback for browsers without :has() — hide the dropdown only while Kaching cards are actually rendered
  var picker = root.querySelector('[data-voss-picker]');
  function checkKaching() {
    if (!picker) return;
    var kb = root.querySelector('kaching-bundle');
    var loaded = kb && (kb.querySelector('.kaching-bundles__block--loaded') || kb.getBoundingClientRect().height > 10);
    picker.style.display = loaded ? 'none' : '';
  }
  checkKaching();

  if (input) {
    input.addEventListener('change', update);
    // Kaching (and other apps) may set input.value without firing events — poll as a fallback.
    setInterval(function () { update(); checkKaching(); }, 400);
  }

  update();

  initVossGallery();
});

/* ------------------------------------------------------------------ *
 * Single-image gallery with vertical left thumbnails + up/down arrows.
 * Reuses Wellina's grid-with-thumbnail DOM (thumbs + main media items,
 * matched by data-media-id) but shows ONE main image at a time and swaps
 * it on thumb click / arrow press. Desktop only; mobile keeps the native
 * swipe carousel. Neutralizes the theme's scroll-to-image behavior.
 * ------------------------------------------------------------------ */
function initVossGallery() {
  var gallery = document.querySelector('.product-information--main media-gallery.media-gallery--main')
    || document.querySelector('.product-information__media media-gallery');
  if (!gallery || gallery.dataset.vossGallery) return;

  var wrapper = gallery.querySelector('.media-gallery__carousel-wrapper');
  var thumbs = gallery.querySelector('.media-gallery__grid-thumbnails');
  if (!wrapper) return;

  // Single-image products have no thumbnail strip. Our CSS hides every main item except
  // .voss-mediashow, so without revealing the one image here the gallery would be blank.
  if (!thumbs) {
    gallery.dataset.vossGallery = '1';
    var onlyItem = wrapper.querySelector(':scope > .media-gallery__item');
    if (onlyItem) {
      onlyItem.classList.add('voss-mediashow');
      var oimg = onlyItem.querySelector('img');
      if (oimg) {
        oimg.setAttribute('loading', 'eager');
        var os = oimg.getAttribute('src') || '', oss = oimg.getAttribute('srcset') || '';
        if (oss) { oimg.setAttribute('srcset', ''); oimg.setAttribute('srcset', oss); }
        if (os) { oimg.setAttribute('src', ''); oimg.setAttribute('src', os); }
      }
    }
    return;
  }

  gallery.dataset.vossGallery = '1';

  // 1) Pull any deferred main slides into the DOM so every image exists up front,
  //    then drop the templates so the theme's progressive loader is a no-op.
  var tplSlides = gallery.querySelector('template[data-deferred-slides]');
  if (tplSlides && tplSlides.content) {
    wrapper.appendChild(tplSlides.content.cloneNode(true));
    tplSlides.remove();
  }
  var tplThumbs = gallery.querySelector('template[data-deferred-thumbnails]');
  if (tplThumbs) tplThumbs.remove();

  // De-dupe main items by media-id (guard against a race with the theme loader).
  var seen = {};
  Array.prototype.slice.call(wrapper.querySelectorAll(':scope > .media-gallery__item[data-media-id]'))
    .forEach(function (el) {
      var id = el.getAttribute('data-media-id');
      if (seen[id]) { el.remove(); } else { seen[id] = 1; }
    });

  var items = Array.prototype.slice.call(wrapper.querySelectorAll(':scope > .media-gallery__item[data-media-id]'));
  var thumbBtns = Array.prototype.slice.call(thumbs.querySelectorAll('.media-gallery__item[data-media-id]'));
  if (!items.length || !thumbBtns.length) return;

  // Deferred slides are cloned out of an inert <template>; native lazy-loading
  // doesn't reliably fire for them once revealed (they'd stay a blank white box),
  // so force every main gallery image to load up front. NOTE: in Chrome, setting
  // src/srcset to the *same* value is a no-op — it won't re-fetch — so we clear
  // then restore srcset+src to force the image-source-selection algorithm to run.
  function ensureLoaded(el) {
    if (!el) return;
    var img = el.querySelector('img');
    if (!img) return;
    if (img.complete && img.naturalWidth > 0) return; // already loaded
    var wasLazy = img.getAttribute('loading') === 'lazy';
    img.setAttribute('loading', 'eager');
    if (wasLazy || img.naturalWidth === 0) {
      var src = img.getAttribute('src') || '';
      var srcset = img.getAttribute('srcset') || '';
      if (srcset) { img.setAttribute('srcset', ''); img.setAttribute('srcset', srcset); }
      if (src) { img.setAttribute('src', ''); img.setAttribute('src', src); }
    }
  }
  items.forEach(ensureLoaded);
  // Thumbnails are lazy too; on products with many images the in-viewport lazy thumbs
  // never fire (theme's progressive loader is neutralized), so eager-load them as well.
  thumbBtns.forEach(ensureLoaded);

  // 2) Neutralize the theme's grid-thumb handler (it scrolls the page + reorders).
  try { gallery.handleGridThumbClick = function () {}; } catch (e) {}

  var currentId = null;

  function indexOfId(id) {
    for (var i = 0; i < thumbBtns.length; i++) {
      if (thumbBtns[i].getAttribute('data-media-id') === String(id)) return i;
    }
    return 0;
  }

  function scrollThumbIntoView() {
    var el = thumbBtns[indexOfId(currentId)];
    if (!el) return;
    var top = el.offsetTop;
    var bottom = top + el.offsetHeight;
    if (top < thumbs.scrollTop) {
      thumbs.scrollTop = top - 4;
    } else if (bottom > thumbs.scrollTop + thumbs.clientHeight) {
      thumbs.scrollTop = bottom - thumbs.clientHeight + 4;
    }
  }

  function updateArrows() {
    var i = indexOfId(currentId);
    var last = thumbBtns.length - 1;
    up.disabled = i <= 0;
    down.disabled = i >= last;
    // main-image left/right arrows: left hidden on the first slide, right on the last
    if (prevA) prevA.classList.toggle('voss-hidden', i <= 0);
    if (nextA) nextA.classList.toggle('voss-hidden', i >= last);
  }

  function show(id) {
    id = String(id);
    items.forEach(function (el) {
      var on = el.getAttribute('data-media-id') === id;
      el.classList.toggle('voss-mediashow', on);
      if (on) ensureLoaded(el);
    });
    thumbBtns.forEach(function (b) {
      var active = b.getAttribute('data-media-id') === id;
      b.classList.toggle('is-active', active);
      if (active) { b.setAttribute('aria-current', 'true'); }
      else { b.removeAttribute('aria-current'); }
    });
    currentId = id;
    scrollThumbIntoView();
    updateArrows();
  }

  // 3) Intercept thumb clicks in capture phase so the theme handler never runs.
  thumbBtns.forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopImmediatePropagation();
      e.preventDefault();
      show(b.getAttribute('data-media-id'));
    }, true);
  });

  // 4) Build the vertical up/down nav around the thumbnail strip.
  var container = gallery.querySelector('.media-gallery--has-grid-thumbs') || thumbs.parentNode;
  var nav = document.createElement('div');
  nav.className = 'voss-thumbnav';

  var up = document.createElement('button');
  up.type = 'button';
  up.className = 'voss-thumb-arrow voss-thumb-up';
  up.setAttribute('aria-label', 'Vorheriges Bild');
  up.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"/></svg>';

  var down = document.createElement('button');
  down.type = 'button';
  down.className = 'voss-thumb-arrow voss-thumb-down';
  down.setAttribute('aria-label', 'Nächstes Bild');
  down.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';

  container.insertBefore(nav, thumbs);
  nav.appendChild(up);
  nav.appendChild(thumbs);
  nav.appendChild(down);
  thumbs.classList.remove('sticky-element');

  up.addEventListener('click', function () {
    var i = indexOfId(currentId);
    if (i > 0) show(thumbBtns[i - 1].getAttribute('data-media-id'));
  });
  down.addEventListener('click', function () {
    var i = indexOfId(currentId);
    if (i < thumbBtns.length - 1) show(thumbBtns[i + 1].getAttribute('data-media-id'));
  });

  // 5) Build the left/right prev-next arrows ON the main image (like the live theme).
  wrapper.style.position = 'relative';
  var prevA = document.createElement('button');
  prevA.type = 'button';
  prevA.className = 'voss-main-arrow voss-main-prev';
  prevA.setAttribute('aria-label', 'Vorheriges Bild');
  prevA.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>';

  var nextA = document.createElement('button');
  nextA.type = 'button';
  nextA.className = 'voss-main-arrow voss-main-next';
  nextA.setAttribute('aria-label', 'Nächstes Bild');
  nextA.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"/></svg>';

  wrapper.appendChild(prevA);
  wrapper.appendChild(nextA);

  prevA.addEventListener('click', function () {
    var i = indexOfId(currentId);
    if (i > 0) show(thumbBtns[i - 1].getAttribute('data-media-id'));
  });
  nextA.addEventListener('click', function () {
    var i = indexOfId(currentId);
    if (i < thumbBtns.length - 1) show(thumbBtns[i + 1].getAttribute('data-media-id'));
  });

  // 6) Exactly VISIBLE_THUMBS SQUARE (1:1) thumbnails, the last flush at the main
  //    image's bottom edge. The thumbnail column width follows the computed square
  //    size (client: images must not look stretched/cropped into a wide box).
  var VISIBLE_THUMBS = 6;
  function syncThumbHeight() {
    if (window.innerWidth < 768) {
      thumbs.style.maxHeight = '';
      thumbBtns.forEach(function (b) { b.style.height = ''; });
      gallery.style.removeProperty('--media-grid-thumbs-size');
      return;
    }
    var h = wrapper.getBoundingClientRect().height;
    if (h <= 40) return;
    // Cap the strip at the main-image height (no blank space, rest scroll)...
    thumbs.style.maxHeight = h + 'px';
    if (thumbBtns.length >= VISIBLE_THUMBS) {
      var gap = parseFloat(getComputedStyle(thumbs).rowGap) || 10;
      var th = (h - (VISIBLE_THUMBS - 1) * gap) / VISIBLE_THUMBS;
      if (th > 20) {
        thumbBtns.forEach(function (b) { b.style.height = th + 'px'; });
        // square thumbs: the grid column width = the thumb height. Narrowing the column
        // widens the main image, which changes h — the ResizeObserver re-runs this and
        // the 1px guard stops the loop once it converges.
        var current = parseFloat(gallery.style.getPropertyValue('--media-grid-thumbs-size')) || 0;
        if (Math.abs(current - th) > 1) {
          gallery.style.setProperty('--media-grid-thumbs-size', th.toFixed(2) + 'px');
        }
      }
    }
  }

  // 7) Initialise on the first image, then size the thumbnail strip.
  show(thumbBtns[0].getAttribute('data-media-id'));
  syncThumbHeight();

  // Recompute whenever the main image changes size so the 5 thumbs stay flush at EVERY
  // desktop width. A plain resize event can fire before the responsive image re-lays-out,
  // so we measure on the next animation frame plus a trailing timeout, and also use a
  // ResizeObserver on the main image (fires exactly when its box changes).
  var syncT;
  function scheduleSync() {
    requestAnimationFrame(syncThumbHeight);
    clearTimeout(syncT);
    syncT = setTimeout(syncThumbHeight, 150);
  }
  window.addEventListener('resize', scheduleSync);
  window.addEventListener('load', scheduleSync);
  if (window.ResizeObserver) {
    new ResizeObserver(function () { syncThumbHeight(); }).observe(wrapper);
  }
  setTimeout(syncThumbHeight, 400);
}
